import React from 'react'
import SliderGallery from '../components/SliderGallery'



const RowanGallery = () => {

  const galleryImages = [
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Dec-7-ROWAN-Image-2-v1.2-HighRes.jpg",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Dec-7-ROWAN-Balcony-Image-v1.2-HighRes.jpg",
      alt:'Dec-Tec membrane in various applications and settings 2'
    },
    {
      img: "/assets/Rowan/Rowan 1.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 3'
    },
    {
      img: "/assets/Rowan/Rowan 2.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "/assets/Rowan/Rowan 3.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 5'
    },
    {
      img: "/assets/Rowan/Rowan 4.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 6'
    },
    {
      img: "/assets/Rowan/Rowan 5.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 7'
    },
    {
      img: "/assets/Rowan/Rowan 6.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 8'
    },
    {
      img: "/assets/Rowan/Rowan 7.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 9'
    },
    {
      img: "/assets/Rowan/Rowan 8.jpg",
      alt: 'Dec-Tec membrane in various applications and settings 10'
    }
  ]

  return (
    <div>
      <SliderGallery
        title="Rowan"
        para1="Compliment your tan, brown, or beige tones on your house with Rowan. A flattering slatted wood design integrated with proven features and benefits will upgrade your outdoor living space and have your friends dropping ‘wow’ bombs."
        galleryImages={galleryImages}
        previouslink="/harland-gallery/"
        nextlink="/grafton-gallery-2/"
      />
    </div>
  )
}

export default RowanGallery
